import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { getListAttachImageByAiChatPost } from '@/service/chatAIService';

import ViewImage from './ViewImage';
import ViewDocument from './ViewDocument';

/**
 * Render the files generated by AI (postType = MSG_FILES) under the AI answer.
 * Images are shown as image cards, other files as document cards.
 */
function RenderAttachFileOnAiChatPost({ messageData }) {
    const [attachImages, setAttachImages] = useState([]);
    const [attachDocuments, setAttachDocuments] = useState([]);

    useEffect(() => {
        let isCancelled = false;

        getListAttachImageByAiChatPost(messageData)
            .then(listAttachments => {
                if (isCancelled || Utils.isEmptyArray(listAttachments)) return;

                const images = [];
                const documents = [];
                listAttachments.forEach(attachment => {
                    const extension = Utils.getFileExtension(attachment?.s3Path || '');
                    if (Constant.ATTACH_FILE_IMAGE_LIST_EXTENSIONS.includes(extension?.toLowerCase())) {
                        images.push(attachment);
                    } else {
                        documents.push(attachment);
                    }
                });

                setAttachImages(images);
                setAttachDocuments(documents);
            })
            .catch(error => {
                console.log('getListAttachImageByAiChatPost error ', error);
            });

        return () => {
            isCancelled = true;
        };
    }, [messageData]);

    return (
        <>
            {!Utils.isEmptyArray(attachImages) && (
                <div className="ai-render-attach-img-list">
                    {attachImages.map(attData => (
                        <ViewImage key={attData?.id || attData?.s3Path} imageData={attData} />
                    ))}
                </div>
            )}

            {!Utils.isEmptyArray(attachDocuments) && (
                <div className="ai-render-attach-document-list">
                    {attachDocuments.map(doc => (
                        <ViewDocument key={doc?.id || doc?.s3Path} documentData={doc} />
                    ))}
                </div>
            )}
        </>
    );
}

RenderAttachFileOnAiChatPost.propTypes = {
    messageData: PropTypes.object.isRequired
};

export default RenderAttachFileOnAiChatPost;
